import React from "react";
import { css } from "emotion";
import { Link } from "react-router-dom";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MobileHeader = ({ isBackButton, children }) => {
  return (
    <div className={container}>
      <Link to={`/${isBackButton ? "view" : "home"}`} className="back-button">
        <FontAwesomeIcon className="icon" icon="chevron-left" />
        <p>{isBackButton ? "BACK" : "HOME"}</p>
      </Link>
      {children}
    </div>
  );
};

export default MobileHeader;

const container = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${boxStyles.standardPadding};
  margin-bottom: 15px;
  .back-button {
    display: flex;
    align-items: center;
    color: ${colors.placeholderText};
    text-decoration: none;
    font-size: ${textSizes.normal};
    .icon {
      font-size: 10px;
      margin-right: 5px;
    }
  }
`;
